var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuetzalesRetos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "quetzal-circulo",
    transform: "translate(-25.5 -25.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31630",
    "data-name": "Path 31630",
    d: "M82.993,71.13a5.79,5.79,0,0,1-.32,1.836l1.218,1.3a1.432,1.432,0,0,1,0,1.932,1.219,1.219,0,0,1-1.807,0l-.884-.946a4.866,4.866,0,0,1-3.333,1.357H75.316a5.32,5.32,0,0,1-5.127-5.481V62.922a5.32,5.32,0,0,1,5.127-5.481h2.551a5.32,5.32,0,0,1,5.127,5.481ZM75.3,73.87h2.551a2.409,2.409,0,0,0,1.525-.548l-.923-.987a1.432,1.432,0,0,1,0-1.932,1.219,1.219,0,0,1,1.807,0l.154.164V62.922a2.664,2.664,0,0,0-2.563-2.741H75.3a2.664,2.664,0,0,0-2.563,2.741V71.13A2.664,2.664,0,0,0,75.3,73.87Z",
    transform: "translate(-35.037 -25.517)",
    fill: "#003865",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31631",
    "data-name": "Path 31631",
    d: "M25.5,41.5a16,16,0,1,1,16,16A16.013,16.013,0,0,1,25.5,41.5Zm2.667,0A13.333,13.333,0,1,0,41.5,28.169,13.355,13.355,0,0,0,28.167,41.5Z",
    transform: "translate(0 0)",
    fill: "#003865",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuetzalesRetos);
export default __webpack_public_path__ + "static/media/quetzales-retos.c5c392b82dd62d78b6166d4cc45eec5d.svg";
export { ForwardRef as ReactComponent };